(function () {
  'use strict';

  var translations = {
    'Customer Reviews': 'تقييمات العملاء',
    'Be the first to write a review': 'كن أول من يكتب تقييمًا',
    'Write a review': 'اكتب تقييمًا',
    'No items found': 'لا توجد تقييمات'
  };

  function translateTextNode(node) {
    var source = (node.nodeValue || '').trim();
    if (!translations[source]) return;
    node.nodeValue = node.nodeValue.replace(source, translations[source]);
  }

  function translateAttributes(element) {
    ['aria-label', 'title', 'placeholder'].forEach(function (attribute) {
      var value = element.getAttribute && element.getAttribute(attribute);
      if (translations[value]) element.setAttribute(attribute, translations[value]);
    });
  }

  function translateTree(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE) translateAttributes(root);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    var current = walker.nextNode();
    while (current) {
      if (current.nodeType === Node.TEXT_NODE) translateTextNode(current);
      else translateAttributes(current);
      current = walker.nextNode();
    }
  }

  translateTree(document.body);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') translateTextNode(mutation.target);
      mutation.addedNodes.forEach(translateTree);
    });
  }).observe(document.body, { childList: true, characterData: true, subtree: true });
})();
